<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="card-sales-split">
              <h2>Sale Detail : SL0101</h2>
              <ul>
                <li>
                  <a href="javascript:void(0);"
                    ><img src="../../../assets/img/icons/edit.svg" alt="img"
                  /></a>
                </li>
                <li>
                  <a href="javascript:void(0);"
                    ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                  /></a>
                </li>
                <li>
                  <a href="javascript:void(0);"
                    ><img src="../../../assets/img/icons/excel.svg" alt="img"
                  /></a>
                </li>
                <li>
                  <a href="javascript:void(0);"
                    ><img src="../../../assets/img/icons/printer.svg" alt="img"
                  /></a>
                </li>
              </ul>
            </div>
            <div
              class="invoice-box table-height"
              style="
                max-width: 1600px;
                width: 100%;
                overflow: auto;
                margin: 15px auto;
                padding: 0;
                font-size: 14px;
                line-height: 24px;
                color: #555;
              "
            >
              <table
                cellpadding="0"
                cellspacing="0"
                style="width: 100%; line-height: inherit; text-align: left"
              >
                <tbody>
                  <tr class="top">
                    <td colspan="6" style="padding: 5px; vertical-align: top">
                      <table style="width: 100%; line-height: inherit; text-align: left">
                        <tbody>
                          <tr>
                            <td
                              style="
                                padding: 5px;
                                vertical-align: top;
                                text-align: left;
                                padding-bottom: 20px;
                              "
                            >
                              <font style="vertical-align: inherit; margin-bottom: 25px"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #7367f0;
                                    font-weight: 600;
                                    line-height: 35px;
                                  "
                                  >Customer Info</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  walk-in-customer</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  walk-in-customer@example.com</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  123456780</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  N45 , Dhaka</font
                                ></font
                              ><br />
                            </td>
                            <td
                              style="
                                padding: 5px;
                                vertical-align: top;
                                text-align: left;
                                padding-bottom: 20px;
                              "
                            >
                              <font style="vertical-align: inherit; margin-bottom: 25px"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #7367f0;
                                    font-weight: 600;
                                    line-height: 35px;
                                  "
                                  >Company Info</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  DGT
                                </font></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  admin@example.com</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                  >6315996770</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  3618 Abia Martin Drive</font
                                ></font
                              ><br />
                            </td>
                            <td
                              style="
                                padding: 5px;
                                vertical-align: top;
                                text-align: left;
                                padding-bottom: 20px;
                              "
                            >
                              <font style="vertical-align: inherit; margin-bottom: 25px"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #7367f0;
                                    font-weight: 600;
                                    line-height: 35px;
                                  "
                                  >Invoice Info</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  Reference
                                </font></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  Payment Status</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                >
                                  Status</font
                                ></font
                              ><br />
                            </td>
                            <td
                              style="
                                padding: 5px;
                                vertical-align: top;
                                text-align: right;
                                padding-bottom: 20px;
                              "
                            >
                              <font style="vertical-align: inherit; margin-bottom: 25px"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #7367f0;
                                    font-weight: 600;
                                    line-height: 35px;
                                  "
                                  >&nbsp;</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: 400;
                                  "
                                  >SL0101
                                </font></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #2e7d32;
                                    font-weight: 400;
                                  "
                                >
                                  Paid</font
                                ></font
                              ><br />
                              <font style="vertical-align: inherit"
                                ><font
                                  style="
                                    vertical-align: inherit;
                                    font-size: 14px;
                                    color: #2e7d32;
                                    font-weight: 400;
                                  "
                                >
                                  Completed</font
                                ></font
                              ><br />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr class="heading" style="background: #f3f2f7">
                    <td
                      style="
                        padding: 5px;
                        vertical-align: middle;
                        font-weight: 600;
                        color: #5e5873;
                        font-size: 14px;
                        padding: 10px;
                      "
                    >
                      Product Name
                    </td>
                    <td
                      style="
                        padding: 5px;
                        vertical-align: middle;
                        font-weight: 600;
                        color: #5e5873;
                        font-size: 14px;
                        padding: 10px;
                      "
                    >
                      QTY
                    </td>
                    <td
                      style="
                        padding: 5px;
                        vertical-align: middle;
                        font-weight: 600;
                        color: #5e5873;
                        font-size: 14px;
                        padding: 10px;
                      "
                    >
                      Price
                    </td>
                    <td
                      style="
                        padding: 5px;
                        vertical-align: middle;
                        font-weight: 600;
                        color: #5e5873;
                        font-size: 14px;
                        padding: 10px;
                      "
                    >
                      Discount
                    </td>
                    <td
                      style="
                        padding: 5px;
                        vertical-align: middle;
                        font-weight: 600;
                        color: #5e5873;
                        font-size: 14px;
                        padding: 10px;
                      "
                    >
                      TAX
                    </td>
                    <td
                      style="
                        padding: 5px;
                        vertical-align: middle;
                        font-weight: 600;
                        color: #5e5873;
                        font-size: 14px;
                        padding: 10px;
                      "
                    >
                      Subtotal
                    </td>
                  </tr>

                  <tr class="details" style="border-bottom: 1px solid #e9ecef">
                    <td
                      style="
                        padding: 10px;
                        vertical-align: top;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <img
                        src="../../../assets/img/product/product1.jpg"
                        alt="img"
                        class="me-2"
                        style="width: 40px; height: 40px"
                      />
                      Macbook pro
                    </td>
                    <td style="padding: 10px; vertical-align: top">1.00</td>
                    <td style="padding: 10px; vertical-align: top">1500.00</td>
                    <td style="padding: 10px; vertical-align: top">0.00</td>
                    <td style="padding: 10px; vertical-align: top">0.00</td>
                    <td style="padding: 10px; vertical-align: top">1500.00</td>
                  </tr>
                  <tr class="details" style="border-bottom: 1px solid #e9ecef">
                    <td
                      style="
                        padding: 10px;
                        vertical-align: top;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <img
                        src="../../../assets/img/product/product7.jpg"
                        alt="img"
                        class="me-2"
                        style="width: 40px; height: 40px"
                      />
                      Apple Earpods
                    </td>
                    <td style="padding: 10px; vertical-align: top">1.00</td>
                    <td style="padding: 10px; vertical-align: top">2000.00</td>
                    <td style="padding: 10px; vertical-align: top">0.00</td>
                    <td style="padding: 10px; vertical-align: top">0.00</td>
                    <td style="padding: 10px; vertical-align: top">1500.00</td>
                  </tr>
                  <tr class="details" style="border-bottom: 1px solid #e9ecef">
                    <td
                      style="
                        padding: 10px;
                        vertical-align: top;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <img
                        src="../../../assets/img/product/product8.jpg"
                        alt="img"
                        class="me-2"
                        style="width: 40px; height: 40px"
                      />
                      samsung
                    </td>
                    <td style="padding: 10px; vertical-align: top">1.00</td>
                    <td style="padding: 10px; vertical-align: top">8000.00</td>
                    <td style="padding: 10px; vertical-align: top">0.00</td>
                    <td style="padding: 10px; vertical-align: top">0.00</td>
                    <td style="padding: 10px; vertical-align: top">1500.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Order Tax</label>
                  <input type="text" />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Discount</label>
                  <input type="text" />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Shipping</label>
                  <input type="text" />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Status</label>
                  <vue-select :options="Status" placeholder="Choose Status" />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="total-order w-100 max-widthauto m-auto mb-4">
                    <ul>
                      <li>
                        <h4>Order Tax</h4>
                        <h5>$ 0.00 (0.00%)</h5>
                      </li>
                      <li>
                        <h4>Discount</h4>
                        <h5>$ 0.00</h5>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="total-order w-100 max-widthauto m-auto mb-4">
                    <ul>
                      <li>
                        <h4>Shipping</h4>
                        <h5>$ 0.00</h5>
                      </li>
                      <li class="total">
                        <h4>Grand Total</h4>
                        <h5>$ 0.00</h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <a href="javascript:void(0);" class="btn btn-submit me-2">Update</a>
                <a href="javascript:void(0);" class="btn btn-cancel">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "Sale Details",
      title1: "View sale details",
      Status: ["Choose Status", "Completed", "Inprogress"],
    };
  },
  name: "sales-details",
};
</script>
